export default __webpack_public_path__ + "static/media/hopper.4452efc1.webp";